export const notAllowedChars = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body>
	<p><span>Below characters not allowed in password:</span></p>
	<p><span>#, !, %, $, ^, \`, ~, (, ), *, <, >, ', "</span></p>
</body>
</html>
`